<script lang="ts">
	import {
		DeviceButton,
		DeviceButtonV2,
		type DeviceButtonV2PropsTypes,
	} from '@Shelly/shelly-design-system/index';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
	export let device,
		isWide = false,
		useV2Components = false;
	export let deviceButtonV2Props: Partial<DeviceButtonV2PropsTypes> = {};

	let isLoading = false;
	const cardClick = () => {
		setSidePanelState({ type: 'device', id: device.id, open: true });
	};
</script>

{#if useV2Components}
	<DeviceButtonV2
		{...deviceButtonV2Props}
		id={`control-camera-${device.id}`}
		aria-label={device.name}
		{isWide}
		isActive={isLoading}
		{isLoading}
		disabled={isLoading}
		icon="fal fa-video"
		on:click={(e) => {
			e.stopPropagation();
			cardClick();
		}}
	/>
{:else}
	<DeviceButton
		id={`control-camera-${device.id}`}
		aria-label={device.name}
		{isWide}
		isActive={isLoading}
		{isLoading}
		disabled={isLoading}
		icon="fas fa-video"
		on:click={(e) => {
			e.stopPropagation();
			cardClick();
		}}
	/>
{/if}
